export interface FilterProps<T> {
  searchTerm: string
  filterKey?: keyof T
}

interface FilterData<T> {
  filter: <T>(list: T[], filterConfig: FilterProps<T>) => T[]
  removeAccents: (str: string) => string
}

export const useNormalizedFilter = <T>(): FilterData<T> => {
  const removeAccents = (str: string) => {
    return str.normalize('NFD').replace(/[\u0300-\u036f]/g, '')
  }

  const filter = <T>(list: T[], filterConfig: FilterProps<T>) => {
    const { filterKey, searchTerm } = filterConfig
    const normalizedSearchTerm = removeAccents(searchTerm.toLowerCase())

    const filtered = list.filter(word => {
      const normalizedWord = removeAccents(String(filterKey ? word[filterKey] : word).toLowerCase())
      return normalizedWord.includes(normalizedSearchTerm)
    })

    return filtered
  }

  return { filter, removeAccents }
}
